import React, { useState } from "react";
import { Expand } from "lucide-react";
import PageHero from "../components/PageHero";
import Lightbox from "../components/Lightbox";
import Seo from "../components/Seo";
import { Reveal } from "../components/Common";
import { GALLERY_CATEGORIES } from "../mock/mock";

const Gallery = () => {
  const [tab, setTab] = useState(0);
  const [box, setBox] = useState({ open: false, index: 0 });
  const cat = GALLERY_CATEGORIES[tab];
  const images = cat.items.map((i) => i.src);
  const captions = cat.items.map((i) => i.caption);

  return (
    <div className="bg-noir">
      <Seo
        title="Photo Gallery — Oud Harvest, Plantation & Global Events | Meilleur"
        description="A visual journey through Meilleur Oudh & Aromas — real agarwood oud chips, our North East India plantations, the Israel expert visit, and international exhibitions."
        path="/gallery"
        keywords="oud photos, agarwood gallery, oud chips images, Meilleur plantation photos, oud events"
      />
      <PageHero eyebrow="A Visual Journey" title="Photo" accent="Gallery" image="/gallery/plant-01.jpg" crumbs={["Gallery"]} />

      <section className="py-20 md:py-28">
        <div className="max-w-[1360px] mx-auto px-6 md:px-10">
          {/* Tabs */}
          <div className="flex flex-wrap gap-3 justify-center mb-6">
            {GALLERY_CATEGORIES.map((c, i) => (
              <button
                key={c.id}
                onClick={() => setTab(i)}
                className={`px-6 py-3 text-xs tracking-[0.16em] uppercase rounded-sm border transition-all ${
                  tab === i
                    ? "bg-[var(--green)] text-[var(--cream)] border-[var(--green)]"
                    : "bg-[var(--paper)] text-[var(--ink)] border-[var(--line)] hover:border-[var(--green)]"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
          <Reveal>
            <p className="text-center text-[var(--muted)] max-w-2xl mx-auto mb-14 font-body font-light">{cat.blurb}</p>
          </Reveal>

          {/* Masonry-ish grid */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
            {cat.items.map((item, i) => (
              <button
                key={item.src}
                onClick={() => setBox({ open: true, index: i })}
                className="img-zoom relative w-full mb-5 block break-inside-avoid group"
                aria-label={`Open ${cat.label} photo ${i + 1}`}
              >
                <img src={item.src} alt={item.caption} className="w-full object-cover" loading="lazy" />
                <span className="absolute inset-0 bg-gradient-to-t from-[rgba(14,58,43,0.85)] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <span className="text-left text-[var(--cream)] text-sm font-body leading-snug">{item.caption}</span>
                </span>
                <span className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1.5 text-[var(--cream)] text-[0.62rem] tracking-[0.16em] uppercase bg-[rgba(14,58,43,0.7)] px-3 py-1.5 rounded-sm">
                  <Expand size={12} /> View
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Lightbox
        open={box.open}
        images={images}
        captions={captions}
        index={box.index}
        title={cat.label}
        onClose={() => setBox({ ...box, open: false })}
      />
    </div>
  );
};

export default Gallery;
